<div class="wrapper">
  @if (isFixedLayout()) {
    <odl-callout>{{ 'SETTINGS.FIXED_LAYOUT_INFO' | translate }}</odl-callout>
  }

  <odl-radio-group
    class="theme-selector-group"
    [value]="backgroundColorId()"
    (odl-input)="changeTheme($event)"
  >
    <span slot="label">{{ 'SETTINGS.BACKGROUND_COLOR' | translate }}</span>

    @for (theme of themes(); track theme.id) {
      <nr-theme-selector
        [style.--theme-selector-background-color]="theme.backgroundColor"
        [label]="theme.label | translate"
        [value]="theme.id"
      ></nr-theme-selector>
    }
  </odl-radio-group>

  @if (isFixedLayout()) {
    <nr-range-slider
      [formControl]="sliderZoom"
      [label]="'SETTINGS.ZOOM' | translate"
      [ariaLabel]="'SETTINGS.ZOOM_SLIDER' | translate"
      [min]="0.25"
      [max]="1.75"
      [step]="0.25"
      iconStart="checkbox_hyphen"
      iconEnd="add"
    />
  }

  @if (showColumnOptions()) {
    <odl-radio-group
      class="page-column-group"
      [value]="pageColumns()?.toString()"
      (odl-input)="changePageColumns($event)"
    >
      <span slot="label">{{ 'SETTINGS.COLUMNS' | translate }}</span>

      <odl-toggle-chip
        id="page-columns-one"
        icon="view_column_one"
        name="page-columns"
        value="1"
      ></odl-toggle-chip>
      <odl-tooltip for="#page-columns-one">
        {{ 'SETTINGS.VIEW_COLUMNS.ONE' | translate }}
      </odl-tooltip>
      <odl-toggle-chip
        id="page-columns-two"
        icon="view_column_two"
        name="page-columns"
        value="2"
      ></odl-toggle-chip>
      <odl-tooltip for="#page-columns-two">
        {{ 'SETTINGS.VIEW_COLUMNS.TWO' | translate }}
      </odl-tooltip>
    </odl-radio-group>
  }
</div>
